import ElementUI from 'element-ui'

const reset = () => {
  const Element: any = ElementUI
  //弹出框设置点击蒙层不关闭
  Element.Dialog.props.closeOnClickModal.default = false
  Element.Dialog.props.appendToBody.default = true
  Element.Dialog.props.closeOnPressEscape.default = false
  Element.MessageBox.setDefaults({
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showClose: false
  })
  // 消息对话框点击蒙层不关闭
  // Element.MessageBox.props.closeOnClickModal.default = false
  // Element.MessageBox.props.closeOnPressEscape.default = false
  //表格的斑马线条纹
  // Element.Table.props.stripe = {
  //   type: Boolean,
  //   default: true
  // }

  //表格头部样式
  Element.Table.props.cellStyle = {
    default: () => ({})
  }
}

export default reset
